let productCat = {
    init() {

        if($('body').hasClass('page-categorie')){
            if(window.screenSize < 756){

                $('.page-categorie .btn-filter').click(function(){
                     $('.list-product-filter').slideDown(300);
                })


                setTimeout(function(){

                    $('html').on('click', '.page-categorie .close', function(event) {
                      $('.list-product-filter').slideUp(300);
                    });


                    $('html').on('click', '.page-categorie .source-summary-count', function(event) {
                      $('.list-product-filter').slideUp(300);
                    });

                }, 0);



                $(window).scroll(function() {
                    if ($(this).scrollTop() > 500) {
                        $(".btn-filter").fadeIn(300);

                    } else {
                        $(".btn-filter").fadeOut(300);
                    }
                });

            }

        }
    }
}

export default productCat;
